"use client";

import { useState, useEffect } from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function TheBigDayCountdown() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const [timeLeft, setTimeLeft] = useState({
    days: 145,
    hours: 12,
    minutes: 34,
    seconds: 56
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        let {
          days,
          hours,
          minutes,
          seconds
        } = prev;
        seconds--;
        if (seconds < 0) {
          seconds = 59;
          minutes--;
          if (minutes < 0) {
            minutes = 59;
            hours--;
            if (hours < 0) {
              hours = 23;
              days--;
              if (days < 0) {
                clearInterval(timer);
                return {
                  days: 0,
                  hours: 0,
                  minutes: 0,
                  seconds: 0
                };
              }
            }
          }
        }
        return {
          days,
          hours,
          minutes,
          seconds
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const timeUnits = [{
    label: "Days",
    value: timeLeft.days
  }, {
    label: "Hours",
    value: timeLeft.hours
  }, {
    label: "Minutes",
    value: timeLeft.minutes
  }, {
    label: "Seconds",
    value: timeLeft.seconds
  }];
  return <section id="the-big-day-countdown" className="dark bg-background text-foreground border-y border-border/40 py-12 md:py-20 overflow-hidden">
      <div ref={ref} className={`container mx-auto px-4 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <div className="max-w-4xl mx-auto">
          <div className="grid grid-cols-4 gap-2 sm:gap-4 text-center">
            {timeUnits.map((unit, i) => <div key={unit.label} data-index={i} className="flex flex-col items-center justify-center">
                <span className="font-serif text-4xl sm:text-6xl md:text-7xl lg:text-8xl font-light tabular-nums tracking-tighter text-foreground/90">
                  {String(unit.value).padStart(2, "0")}
                </span>
                <span className="font-sans text-[9px] sm:text-xs md:text-sm uppercase tracking-[0.2em] sm:tracking-[0.3em] text-muted-foreground mt-3 sm:mt-5">
                  {unit.label}
                </span>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}